import { render, staticRenderFns } from "./order_time.vue?vue&type=template&id=60b54019&scoped=true"
import script from "./order_time.vue?vue&type=script&lang=js"
export * from "./order_time.vue?vue&type=script&lang=js"
import style0 from "./order_time.vue?vue&type=style&index=0&id=60b54019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b54019",
  null
  
)

export default component.exports